module.exports = __webpack_public_path__ + "static/body-def3781939b8f94091c3f97035dc17ad.png";